import { Spinner } from 'components/common'
import ConfigBackLink from 'components/configuration/configBackLink'
import MagentoConfigurationForm from 'components/configuration/magentoConfigurationForm'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { ConfigurationWithId } from 'types/configuration'
import { fetchConfigurations } from 'utils/api/configApi'

const MagentoConfigurations = () => {
  const [configuration, setConfiguration] = useState<ConfigurationWithId>()
  const [loading, setLoading] = useState<boolean>(true)

  const getConfig = async () => {
    try {
      const { data } = await fetchConfigurations({ fields: ['magentoApi'] })
      setConfiguration(data)
    } catch (error) {
      /* empty */
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getConfig()
  }, [])

  if (loading) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Spinner size="large" />
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Magento Configurations</title>
      </Helmet>

      <div className="mx-auto max-w-6xl">
        <ConfigBackLink />

        <h1 className="title text-3xl">Magento Configuration</h1>

        <MagentoConfigurationForm configuration={configuration} />
      </div>
    </>
  )
}

export default MagentoConfigurations
